<template>
  <v-dialog
    v-model="modalViewdevis"
    persistent
    max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">Devis de {{ editdevis.nom }}</span>
      </v-card-title>
      <v-flex
        xs12
        md12
        style="margin-top:1em; margin-bottom:1em;"
      >
        <v-divider/>
      </v-flex>
      <v-card-title>{{ editdevis.nom }}</v-card-title>
      <v-card-text v-if="modalViewdevis">
        <v-layout wrap>
          <v-flex
            xs12
            md12
            style="margin-bottom:1em;"
          >
            <div class="text--primary">
              Adresse
            </div>
            <v-flex
              xs12
              md12
            >
              {{ editdevis.adresse }}
            </v-flex>
            <v-flex
              xs12
              md12
            >
              {{ editdevis.cp }} {{ editdevis.ville }}
            </v-flex>
          </v-flex>
          <v-flex
            xs12
            md6
            style="margin-bottom:1em;"
          >
            <div class="text--primary">
              Contacts
            </div>
            <v-flex
              xs12
              md6
            >
              <a :href="'mailto:'+editdevis.mail">{{ editdevis.mail }}</a>
            </v-flex>
            <v-flex
              xs12
              md6
            >
              <a :href="'tel:'+editdevis.tel">{{ editdevis.tel }}</a>
            </v-flex>
          </v-flex>
          <v-flex
            xs12
            md6
          >
            <v-flex
              xs12
              md12
            >
              <div class="text--primary">
                Préférence de contact
              </div>
            </v-flex>
            <v-flex
              v-if="editdevis.selectcontactmail"
              xs12
              md6
            >
              Courriel
            </v-flex>
            <v-flex
              v-if="editdevis.selectcontacttel"
              xs12
              md6
            >
              Téléphone
            </v-flex>
          </v-flex>
          <v-flex
            xs12
            md12
            style="margin-top:1em; margin-bottom:1em;"
          >
            <v-divider/>
          </v-flex>
          <v-flex
            xs12
            md4
          >
            <div class="text--primary">
              Nombre de pièces
            </div>
            {{ editdevis.piece }}
          </v-flex>
          <v-flex
            xs12
            md4
          >
            <div class="text--primary">
              Surface
            </div>
            {{ editdevis.surface }}m²
          </v-flex>
          <v-flex
            xs12
            md4
          >
            <div class="text--primary">
              Nombre d’angles
            </div>
            {{ editdevis.angle }}
          </v-flex>
          <v-flex
            xs12
            md6
          >
            <div class="text--primary">
              Périmètre
            </div>
            {{ editdevis.perimetre }}m
          </v-flex>
          <v-flex
            xs12
            md6
          >
            <div class="text--primary">
              Couleur
            </div>
            {{ editdevis.couleur }}
          </v-flex>
          <v-flex
            xs12
            md12
            style="margin-top:1em;">
            <div class="text--primary">
              Message
            </div>
            {{ editdevis.contenu }}
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          v-if="editdevis.publie != 'end'"
          color="primary darken-1"
          text
          @click="viewDevis()"
        >Terminer</v-btn
        >
        <v-btn
          color="warning darken-1"
          text
          @click="closeModal('Viewdevis')"
        >Fermer</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { db } from '@/plugins/firebase'

export default {
  data: () => ({
    configck: {
      language: 'fr',
      removePlugins: [ 'Heading' ],
      toolbar: [ 'bold', 'italic', 'bulletedList', 'blockQuote' ]
    },
    show: false,
    invalidlog: false,
    menu: false,
    menu1: false,
    loadingstatus: false,
    rules: {
      required: value => !!value || 'Champs requis.',
      min: v => v.length >= 8 || 'Min 8 caractères',
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Courriel invalide.'
      }
    }
  }),
  computed: {
    ...mapGetters(['modalViewdevis', 'editdevis'])
  },
  methods: {
    ...mapActions(['closeModal']),
    viewDevis () {
      this.loadingstatus = true
      const $this = this
      db.collection('devis')
        .doc(this.editdevis.id)
        .update({ publie: 'end' })
        .then(function () {
          $this.closeModal('Viewdevis')
          $this.loadingstatus = false
          console.log('Document fermé!')
        }).catch(function (error) {
          console.error('Erreur de suppression du document: ', error)
        })
    }
  }
}
</script>
